<script setup>
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import {ref} from "vue";
import {useForm} from "laravel-precognition-vue-inertia";

const visible = defineModel('visible');
const sent = ref(false);

const props = defineProps({
    url: String,
    extended: Boolean,
})

const form = useForm('post', props.url, {
    title: '',
    text: '',
    name: '',
    email: '',
});

const send = () => form.submit({
    preserveScroll: true,
    onSuccess: () => {
        form.reset();
        sent.value = true
    }
})
</script>

<template>
    <Dialog v-model:visible="visible" modal :show-header="false">
        <div v-if="!sent" class="flex flex-col justify-center w-full mt-6 gap-4" style="width: 300px">
            <p class="text-xl">{{$t('widget.contact_us')}}</p> <!-- Kontaktujte nás -->
            <template v-if="extended">
                <InputText :placeholder="$t('widget.message_name_placeholder')" v-model="form.name" :invalid="form.invalid('name')"></InputText> <!-- Nadpis zprávy -->
                <small v-if="form.invalid('name')" class="-mt-3 text-red-500">{{form.errors['name']}}</small>
                <InputText :placeholder="$t('widget.message_email_placeholder')" v-model="form.email" type="email" :invalid="form.invalid('email')"></InputText> <!-- Nadpis zprávy -->
                <small v-if="form.invalid('email')" class="-mt-3 text-red-500">{{form.errors['email']}}</small>
            </template>
            <InputText :placeholder="$t('widget.message_title_placeholder')" v-model="form.title" :invalid="form.invalid('title')"></InputText> <!-- Nadpis zprávy -->
            <small v-if="form.invalid('title')" class="-mt-3 text-red-500">{{form.errors['title']}}</small>
            <Textarea :placeholder="$t('widget.message_text_placeholder')" v-model="form.text" :invalid="form.invalid('text')" rows="5"></Textarea> <!-- Text zprávy -->
            <small v-if="form.invalid('text')" class="-mt-3 text-red-500">{{form.errors['text']}}</small>

            <div class="flex gap-4">
                <Button severity="secondary" @click="visible = false" :label="$t('widget.cancel')" fluid></Button> <!-- Zrušit -->
                <Button :label="$t('widget.send')" :loading="form.processing" @click="send" icon="pi pi-send" fluid></Button> <!-- Odeslat -->
            </div>
        </div>
        <div v-else class="flex flex-col justify-center items-center gap-2 mt-6" style="width: 300px">
            <div class="bg-green-100 px-3 pb-2 rounded-full pt-3">
                <i class="pi pi-check-circle text-green-500" style="font-size: 1.75rem"></i>
            </div>
            <p class="text-xl">{{ $t('widget.sent') }}</p>
            <Button severity="secondary" @click="visible = false; sent = false; form.reset()" class="mt-6" :label="$t('widget.ok')" fluid></Button> <!-- OK -->
        </div>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
